import { render, staticRenderFns } from "./PnetMessageNew.vue?vue&type=template&id=928a4cc0"
import script from "./PnetMessageNew.vue?vue&type=script&lang=js"
export * from "./PnetMessageNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports